import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import { connect } from 'react-redux'
import qs from 'qs'
import Icon from '../../components/misc/Icons'
import { confirmEmailUpdate, getEmailUpdateSummary } from '../../actions/user'
import getErrorMessageForRequest from '../../utils/getErrorMessageForRequest'

class ConfirmEmailUpdateContainer extends Component {
  constructor(props) {
    super(props)
    this.handleConfirm = this.handleConfirm.bind(this)
    const urlParams = qs.parse(window.location.search.slice(1))
    const linkBroken = !urlParams.user || !urlParams.token
    this.state = {
      user: urlParams.user,
      token: urlParams.token,
      // 'loadingSummary' | 'confirm' | 'confirming' | 'success' | 'error'
      status: linkBroken ? 'error' : 'loadingSummary',
      currentEmail: null,
      newEmail: null,
      errorMessage: linkBroken ? 'This link is broken. Please make sure the link is not modified.' : '',
    }
    // remove query params from url right away
    // to avoid exposing them in browser history or to third party via url
    props.history.replace(window.location.pathname)
  }

  componentDidMount() {
    const { user, token, status } = this.state
    const { getEmailUpdateSummary } = this.props
    if (status !== 'loadingSummary') return

    getEmailUpdateSummary(user, token)
      .then((response) => {
        this.setState({
          status: 'confirm',
          currentEmail: response.currentEmail,
          newEmail: response.newEmail,
        })
      })
      .catch((error) => {
        const errorMessage = getErrorMessageForRequest({
          requestName: 'getEmailUpdateSummary',
          response: error.response,
        })
        this.setState({ status: 'error', errorMessage })
      })
  }

  handleConfirm() {
    const { user, token } = this.state
    const { confirmEmailUpdate } = this.props

    this.setState({ status: 'confirming' })
    confirmEmailUpdate(user, token)
      .then(() => {
        this.setState({ status: 'success' })
      })
      .catch((error) => {
        const errorMessage = getErrorMessageForRequest({
          requestName: 'confirmEmailUpdate',
          response: error.response,
        })
        this.setState({ status: 'error', errorMessage })
      })
  }

  render() {
    const {
      status, currentEmail, newEmail, errorMessage,
    } = this.state

    return (
      <DocumentTitle title='Confirm Email - Plickers'>
        <div className='confirmEmailUpdatePage'>
          <div className='confirmEmailUpdatePage-card marketing'>
            <div className='confirmEmailUpdatePage-logo'>
              <Icon name='logo-full' />
            </div>
            <div className='confirmEmailUpdatePage-divider' />

            {(status === 'loadingSummary' || status === 'confirming') && (
              <div className='confirmEmailUpdatePage-title confirmEmailUpdatePage-title--loading'>
                {status === 'confirming' ? 'Updating your email...' : 'Loading...'}
              </div>
            )}

            {status === 'confirm' && (
              <React.Fragment>
                <div className='confirmEmailUpdatePage-title'>
                  Confirm Email Change
                </div>
                <div className='confirmEmailUpdatePage-message'>
                  You requested to change the email address on your Plickers account.
                </div>

                <div className='confirmEmailUpdatePage-emailChange'>
                  <div className='confirmEmailUpdatePage-emailChange-row'>
                    <div className='confirmEmailUpdatePage-emailChange-label'>Current</div>
                    <div className='confirmEmailUpdatePage-emailChange-email'>{currentEmail}</div>
                  </div>
                  <div className='confirmEmailUpdatePage-emailChange-arrow'>↓</div>
                  <div className='confirmEmailUpdatePage-emailChange-row'>
                    <div className='confirmEmailUpdatePage-emailChange-label'>New</div>
                    <div className='confirmEmailUpdatePage-emailChange-email confirmEmailUpdatePage-emailChange-email--new'>
                      {newEmail}
                    </div>
                  </div>
                </div>

                <button
                  type='button'
                  className='confirmEmailUpdatePage-confirmBtn'
                  onClick={this.handleConfirm}
                >
                  Confirm Email Change
                </button>
              </React.Fragment>
            )}

            {status === 'success' && (
              <React.Fragment>
                <div className='confirmEmailUpdatePage-checkIcon'>
                  <Icon name='check-circle' />
                </div>
                <div className='confirmEmailUpdatePage-title'>
                  Email Updated
                </div>
                <div className='confirmEmailUpdatePage-message'>
                  Your Plickers email address is now
                  {' '}
                  <span className='confirmEmailUpdatePage-message-email'>{newEmail}</span>
                  . For security, you’ve been signed out everywhere - please sign in again.
                </div>
                <button
                  type='button'
                  className='confirmEmailUpdatePage-confirmBtn'
                  onClick={() => {
                    // full navigation (not history.push) - the app's isAuthenticated
                    // state is stale from before confirming invalidated the session,
                    // so a client-side route to /login would bounce back to /library
                    window.location = '/login'
                  }}
                >
                  Go to Login
                </button>
              </React.Fragment>
            )}

            {status === 'error' && (
              <React.Fragment>
                <div className='confirmEmailUpdatePage-title confirmEmailUpdatePage-title--error'>
                  Something Went Wrong
                </div>
                <div className='confirmEmailUpdatePage-message'>
                  {errorMessage}
                </div>
                {/* the token was already validated by the summary fetch, so a failed
                    confirm attempt (e.g. a network blip) is worth retrying - unlike a
                    broken/expired link, which the button below never appears for */}
                {currentEmail && newEmail && (
                  <button
                    type='button'
                    className='confirmEmailUpdatePage-confirmBtn'
                    onClick={this.handleConfirm}
                  >
                    Try Again
                  </button>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default withRouter(connect(
  (/* state */) => ({}),
  { confirmEmailUpdate, getEmailUpdateSummary },
)(ConfirmEmailUpdateContainer))
